import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
	selector: 'lead-source-color',
	template: require('./lead-source-color.html')
})
export class LeadSourceColorComponent implements OnInit {
	@Input() color: string;
	// -100 to 0 is darkened
	// 0 to 100 is lighten
	@Input() borderShadePercentage = -20;

	borderColor: string;

	constructor() {}

	ngOnInit(): void {
		this.changeBorderColor();
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!changes.color.isFirstChange() && changes.color.currentValue) {
			this.changeBorderColor();
		}
	}

	private shadeColor(color: string, percent: number): string {
		let R = parseInt(color.substring(1, 3), 16);
		let G = parseInt(color.substring(3, 5), 16);
		let B = parseInt(color.substring(5, 7), 16);

		R = parseInt(String((R * (100 + percent)) / 100));
		G = parseInt(String((G * (100 + percent)) / 100));
		B = parseInt(String((B * (100 + percent)) / 100));

		R = R < 255 ? R : 255;
		G = G < 255 ? G : 255;
		B = B < 255 ? B : 255;

		const RR =
			R.toString(16).length === 1 ? `0${R.toString(16)}` : R.toString(16);
		const GG =
			G.toString(16).length === 1 ? `0${R.toString(16)}` : G.toString(16);
		const BB =
			B.toString(16).length === 1 ? `0${R.toString(16)}` : B.toString(16);

		return `#${RR}${GG}${BB}`;
	}

	private changeBorderColor(): void {
		if (this.color) {
			this.borderColor = this.shadeColor(
				this.color,
				this.borderShadePercentage
			);
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./shared/components/common/lead-source-color/lead-source-color.ts